import React, { useEffect, useState } from "react";
import MainContainer from "../../components/app/maincontainer";
import Header from "../../components/partials/header";
import AllTools from "../../assets/icons/all-tools.svg";
import TotalUtility from "../../assets/icons/total-tools.svg";
import TotalRegulatory from "../../assets/icons/regulatory-tools.svg";
import TotalRegion from "../../assets/icons/total-regions.svg";
import ToolsTable from "../../components/tables/tools-table";
import { AddUsersModal } from "../../components/modals/addtoolsmodal";
import { useNavigate } from "react-router-dom";
import { useToolsStore } from "../../data/stores/loggerStore";
import { apiCall } from "../../data/useFetcher";
import RawSample from "../../assets/Tool Bulk Upload Sample.xlsx";
import { toast } from "react-toastify";
import useErrorStore from "../../data/stores/errorStore";
import DoneModal from "../../components/modals/donemodal";

const Tools = () => {
	let { getLogger, getDynamicLogger, data, stat }: any = useToolsStore();
	const [modal, setModal] = useState("");
	const Arr = [
			{ icon: AllTools, value: data?.totalDocs || 0, title: "All tools" },
			{
				icon: TotalUtility,
				value: stat?.utility || 0,
				title: "total utility tools",
			},
			{
				icon: TotalRegulatory,
				value: stat?.regulatory || 0,
				title: "Total regulatory tools",
			},
			{
				icon: TotalRegion,
				value: stat?.national || 0,
				title: "total national tools",
			},
		],
		[tab, setTab] = useState("all tools"),
		tabs = ["all tools", "Newly uploaded tools"],
		navigate = useNavigate();

	const toggleUploadModal = () => {
		setModal("");
	};

	useEffect(() => {
		apiCall({
			type: "get",
			url: `/api/v1/tools${tab !== tabs?.[0] ? `?streamline=week` : ""}`,
			getter: (d: any) =>
				tab !== tabs?.[0] ? getDynamicLogger(d, "recent") : getLogger(d),
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tab]);

	useEffect(() => {
		apiCall({
			type: "get",
			url: `/api/v1/tools/stat`,
			getter: (d: any) => getDynamicLogger(d, "stat"),
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	let [loading, setLoading] = useState(null),
		{ returnErrors } = useErrorStore();
	const onSubmit = async (data: any[]) => {
		if (!data || data?.length === 0)
			return toast.info("Tools' details required");
		setLoading(true);

		let { response, errArr, errMsg } = await apiCall({
			type: "put",
			url: `/api/v1/tools/manage-tools`,
			data: {
				tools: data,
			},
		});
		// console.log({ response, errArr, errMsg });
		if (errArr) {
			setLoading(false);
			return returnErrors(errArr);
		}
		if (errMsg) {
			setLoading(false);
			return toast.error(errMsg);
		}
		setLoading(false);
		if (response) {
			apiCall({
				type: "get",
				url: `/api/v1/tools${tab !== tabs?.[0] ? `?streamline=week` : ""}`,
				getter: (d: any) =>
					tab !== tabs?.[0] ? getDynamicLogger(d, "recent") : getLogger(d),
			});
			apiCall({
				type: "get",
				url: `/api/v1/tools/stat`,
				getter: (d: any) => getDynamicLogger(d, "stat"),
			});
			setModal("done");
			return;
		}
		setLoading(false);
	};

	return (
		<div>
			<MainContainer>
				<Header
					btn2Text={"Add New Tool"}
					btn1Text={"Bulk Upload"}
					handleAdd={() => navigate("add-tool")}
					handleModal={() => setModal("tool")}
					text="Overview"
				/>
				<div className="mt-6 grid grid-cols-4 gap-6">
					{Arr?.map(it => (
						<div
							style={{
								border: "1px solid #F1F5F9",
								boxShadow: "4px 4px 100px 0px #00000014",
							}}
							className="bg-white rounded-lg h-24 px-5 flex items-center justify-between">
							<div>
								<h4 className="text-sm font-medium inter text-da-blue-600 capitalize">
									{it?.title}
								</h4>{" "}
								<div className="mt-3">
									<strong className="text-xl  font-bold text-da-blue-600 inter">
										{it?.value}
									</strong>
								</div>
							</div>
							<img src={it?.icon} alt="" className="" />
						</div>
					))}
				</div>
				<div className="mt-8 bg-white rounded-lg p-6">
					<div className="h-16 border-b border-b-[#E3E3E3] flex gap-4">
						{tabs?.map(t => (
							<button
								onClick={() => setTab(t)}
								className={`h-full capitalize px-1 text-base ${
									tab === t
										? "font-medium border-b-4 text-[#111014] border-b-[#2658AB]"
										: "font-normal border-b-none text-[#878789]"
								}`}>
								{t}
							</button>
						))}
					</div>
					<div className="mt-4">
						<ToolsTable tab={tab} tabs={tabs} />
					</div>
				</div>
			</MainContainer>
			{modal === "tool" && (
				<AddUsersModal
					handleClose={toggleUploadModal}
					title={"Upload new tool"}
					subtitle="Add new tool"
					handleImport={async pres2 => {
						await onSubmit(pres2);
					}}
					sample={RawSample}
					loading={loading}
				/>
			)}
			{modal === "done" && (
				<DoneModal
					page={"Tool"}
					handleClose={() => setModal("")}
					close={() => setModal("")}
					path={"/tools"}
				/>
			)}
		</div>
	);
};

export default Tools;
